import {Fragment } from 'react';

import { useTranslation } from 'react-multi-lang';
import MyCheckBox from '../buttons/check';
import GreenButton from '../buttons/green-button';
import { SimpleCheckbox } from '../FormElements/FormElements';

import { Tooltip } from '@mui/material';
import SortWidget from '../SortWidget/SortWidget';

import { useGetSort } from '../../services/hoc/useSort';

interface iProps {
  data: any[];
  header: string[];
  onSelect?: Function;
  hasMore: boolean;
  loadMore: Function;
  editRow?: Function;
  deleteRow?: Function;
  key_header:string[],
  this_for:string,
  button_structure?:string[],
  button_type?:{[key:string]:string},
  button_functions?:{[key:string]:Function},
  sort_fields?:(number|undefined)[],
  fetchSortedData?:Function
}
const MyDashboardTable = (props: iProps) => {

  // Translation
  const t = useTranslation();
  const {handleSort,sortChecked}=useGetSort(props.sort_fields,props.fetchSortedData,)
  //const [sortChecked,setSort]=useState({selectedIndex:-1,trigger:false ,up:false,down:false})

  let scroll: any = null;

  const selectRow = (e: React.MouseEvent<HTMLTableRowElement>, id?: any) => {
    // Toggle active class
    e.currentTarget.classList.toggle('active');

    // Toggle checkbox
    let checkbox: HTMLInputElement | null = e.currentTarget.querySelector(
      "input[type='checkbox']",
    );
    checkbox?.click();

    // Fire select function
    if (props.onSelect && id) props.onSelect(id);
  };

  // Reset scroller
  // useImperativeHandle(ref, () => ({

  //     reset() {
  //         scroll.pageLoaded = 0
  //     }

  // }));
  interface iTest {
    [key: string]: any;
  }
  // useEffect(()=>{
  //   if (sortChecked) {
     
  //     if (props.fetchSortedData && sortChecked.selectedIndex>-1) {
  //       let field_id= props.sort_fields?.[ sortChecked.selectedIndex]
  //       let sort_direction:sortDirectionType=sortChecked.down? 'DES':sortChecked.up?'ASC':'ASC'
  //       props.fetchSortedData( field_id,sort_direction)
  //     }
      
  //   }
  // },[sortChecked])

  const editRow=(ele:any)=>{
    
    if (props.this_for==='service' && props.editRow) props.editRow(ele)
    if (props.this_for==='glass_work' && props.editRow) props.editRow(ele)
   
    
  }
  const deleteRow=(ele:any)=>{
    
    if (props.this_for==='glass_work' && props.deleteRow)  props.deleteRow(ele)
    if (props.this_for==='service' && props.deleteRow)props.deleteRow(ele.pid)
  }

  return (
    <div className="dashboard-table">
      <table>
        {
          /* props.hasMore && */ props.data.length === 0 ? (
            ''
          ) : (
            <thead>
              <tr>
                {props.onSelect && <th></th>}
                {props.header.map((item: any, index: number) => (
                  <th style={item ? {} : { width: '200px' }} key={`${index}` +item}
                  onClick={()=>
                    handleSort(index)
                   }
                  >
                    <SortWidget 
                    item={item}
                    index={index}
                    sort={sortChecked} 
                   
                    show={props.sort_fields?.[index]}
                    
                    />
                    
                  </th>
                ))}
              </tr>
            </thead>
          )
        }
        {!props.hasMore && props.data.length === 0 ? (
          <tr className="no-items text-center">
            <td>{t('no_items_in_table')}</td>
          </tr>
        ) : (
          ''
        )}
          <tbody>
          {props.data && props.data.length !== 0
            ? props.data.map((ele, tr_index) => (
                <tr
                  key={`${tr_index}` +ele}
                  style={{ zIndex: props.data.length - tr_index }}
                  onClick={(e: React.MouseEvent<HTMLTableRowElement>) => {
                    if (props.onSelect) {
                      selectRow(e, ele);
                    }
                  }}>
                  {props.onSelect && (
                    <td width="50">
                      <SimpleCheckbox
                        className="select-row"
                        onClick={(
                          e: React.MouseEvent<HTMLTableDataCellElement>,
                        ) => e.stopPropagation()}
                      />
                    </td>
                  )}
                  {props.key_header.map((key: string, td_index) => {
                    if (td_index === props.header.length - 1) {
                      return (
                        <Fragment key={tr_index + '_' + td_index}>
                          <td key={tr_index + '_' + td_index}>{ele[key]}</td>
                          <td>
                            <div className="show-on-hover">
                              {props.editRow?
                                <Tooltip title={t("edit")}>
                                <i
                                  className="icon-edit"
                                  onClick={(
                                    e: React.MouseEvent<HTMLLIElement>,
                                  ) => {
                                   editRow(ele);
                                  }}
                                />
                                </Tooltip>:null
                              }
                            {  props.deleteRow ?
                            <Tooltip title={t("delete")}>

                                <i
                                  className="icon-delete"
                                  onClick={(e: React.MouseEvent<HTMLLIElement>) =>
                                    deleteRow(ele)
                                  }
                                />
                              </Tooltip>:null}
                            </div>
                          </td>
                        </Fragment>
                      );
                    }
                    else {
                      if (props.button_structure?.includes(key)) {
                        return (
                        <td key={tr_index + '_a' + td_index} 
                        onClick={(e:React.MouseEvent)=>e.stopPropagation()}>
                         { 
                         props.button_type && props.button_type[key]==='check'?
                         <div style={{zIndex:55}}  >

                           <MyCheckBox
                           label={t(key)}
                           value={ele[key]}
                           setValue={props.button_functions?props.button_functions[key]:()=>{}}
                           disabled={false}
                           
                            />
                         </div>
                         :
                          <GreenButton
                          fun={()=>{}}
                          label={t(key)}>

                            {ele[key]}
                          </GreenButton>
                          }
                          </td>

                        )
                      }
                      return(<td key={tr_index + '_d' + td_index}>{ele[key]}</td>)
                    }
                      
                  })}
                </tr>
              ))
            : null}
            </tbody>
        {/* <InfiniteScroll
          ref={(component) => (scroll = component)}
           dataLength={props.data.length}
          hasMore={false}
          next={()=>{}}
          loader={
            <tr className="table-loader" key={0}>
              <div className="center">
                <EllipsisLoader />
              </div>
            </tr>
          }
         >
          <tbody>
          {props.data && props.data.length !== 0
            ? props.data.map((ele, tr_index) => (
                <tr
                  key={tr_index +ele}
                  style={{ zIndex: props.data.length - tr_index }}
                  onClick={(e: React.MouseEvent<HTMLTableRowElement>) => {
                    if (props.onSelect) {
                      selectRow(e, ele);
                    }
                  }}>
                  {props.onSelect && (
                    <td width="50">
                      <SimpleCheckbox
                        className="select-row"
                        onClick={(
                          e: React.MouseEvent<HTMLTableDataCellElement>,
                        ) => e.stopPropagation()}
                      />
                    </td>
                  )}
                  {props.key_header.map((key: string, td_index) => {
                    if (td_index === props.header.length - 1) {
                      return (
                        <>
                          <td key={tr_index + '_' + td_index}>{ele[key]}</td>
                          <td>
                            <div className="show-on-hover">
                              {props.editRow?
                                <Tooltip title={t("edit")}>
                                <i
                                  className="icon-edit"
                                  onClick={(
                                    e: React.MouseEvent<HTMLLIElement>,
                                  ) => {
                                   editRow(ele);
                                  }}
                                />
                                </Tooltip>:null
                              }
                            {  props.deleteRow ?
                            <Tooltip title={t("delete")}>

                                <i
                                  className="icon-delete"
                                  onClick={(e: React.MouseEvent<HTMLLIElement>) =>
                                    deleteRow(ele)
                                  }
                                />
                              </Tooltip>:null}
                            </div>
                          </td>
                        </>
                      );
                    }
                    else {
                      if (props.button_structure?.includes(key)) {
                        return (
                        <td key={tr_index + '_a' + td_index} 
                        onClick={(e:React.MouseEvent)=>e.stopPropagation()}>
                         { 
                         props.button_type && props.button_type[key]==='check'?
                         <div style={{zIndex:55}}  >

                           <MyCheckBox
                           label={t(key)}
                           value={ele[key]}
                           setValue={props.button_functions?props.button_functions[key]:()=>{}}
                           disabled={false}
                           
                            />
                         </div>
                         :
                          <GreenButton
                          fun={()=>{}}
                          label={t(key)}>

                            {ele[key]}
                          </GreenButton>
                          }
                          </td>

                        )
                      }
                      return(<td key={tr_index + '_d' + td_index}>{ele[key]}</td>)
                    }
                      
                  })}
                </tr>
              ))
            : null}
            </tbody>
        </InfiniteScroll> */}
      </table>
    </div>
  );
};
export default MyDashboardTable;
